(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagBottomSheetController', OrderBagBottomSheetController);

    OrderBagBottomSheetController.$inject = ['$mdBottomSheet', 'entity'];

    function OrderBagBottomSheetController($mdBottomSheet, entity) {
        var vm = this;

        vm.orderBag = entity.orderBag;
        vm.invoiceInfo = entity.invoiceInfo;
        vm.mode = entity.mode; // MAIN_ACTIONS , OTHER_ACTIONS ,
        vm.constStatus = entity.constStatus;
        vm.resultStatus = entity.resultStatus;
        vm.canReApproveRequestToPay = entity.canReApproveRequestToPay;
        vm.canResendNotification = entity.canResendNotification;
        vm.canDeleteOrderBag = false;
        vm.canIssueInvoice = entity.canIssueInvoice;
        vm.showUseCredit = entity.showUseCredit;


        vm.itemClick = itemClick;
        vm.close = close;

        function itemClick(txt) {
            $mdBottomSheet.hide(txt);
        }

        function close() {
            $mdBottomSheet.hide();
        }
    }
})();
